import React from 'react';
import styled from 'styled-components';
import { Row, Col, Button } from 'react-bootstrap';
import { Select, Input } from 'antd';

const { Option } = Select;

const ControlsBar = styled.div`
    background: #ffffff;
    border-radius: 14px;
    padding: 20px;
    margin-bottom: 20px;
    border: 1px solid #e2e8f0;
    box-shadow: 0 4px 15px rgba(0,0,0,0.02);
`;

const ActiveFilterTag = styled.span`
    display: inline-flex;
    align-items: center;
    background: #fff7ed;
    color: #c2410c;
    font-weight: 700;
    font-size: 12px;
    padding: 5px 12px;
    border-radius: 8px;
    margin-left: 8px;
    border: 1px solid #ffedd5;

    i {
        margin-left: 6px;
        cursor: pointer;
        color: #f97316;
        &:hover {
            color: #ef4444;
        }
    }
`;

export default function HouseholdFiltersBar({
    filters,
    setFilters,
    statesList,
    districtsList,
    blocksList,
    villagesList,
    clustersList,
    lastVisitedByList = [],
    onOpenExport
}) {
    const isAnyFilterActive = filters.search ||
        filters.stage ||
        filters.gender ||
        filters.state ||
        filters.district ||
        filters.block ||
        filters.village ||
        filters.cluster ||
        filters.lastVisitedBy ||
        filters.srlm;

    const resetFilters = () => {
        setFilters({
            search: '',
            stage: '',
            gender: '',
            state: '',
            district: '',
            block: '',
            village: '',
            cluster: '',
            lastVisitedBy: '',
            srlm: ''
        });
    };

    return (
        <ControlsBar>
            <Row className="mb-3 align-items-center">
                <Col md={4} className="mb-2 mb-md-0">
                    <Input
                        placeholder="Search by Name/Mobile..."
                        value={filters.search}
                        onChange={e => setFilters({ ...filters, search: e.target.value })}
                        allowClear
                        prefix={<i className="fa fa-search" style={{ color: '#94a3b8', marginRight: 4 }}></i>}
                        style={{ borderRadius: '8px', padding: '6px 12px' }}
                    />
                </Col>

                <Col md={2} className="mb-2 mb-md-0">
                    <Select
                        placeholder="Stage"
                        style={{ width: '100%' }}
                        allowClear
                        value={filters.stage || undefined}
                        onChange={v => setFilters({ ...filters, stage: v || '' })}
                    >
                        <Option value="advance">Advanced</Option>
                        <Option value="basic">Basic</Option>
                    </Select>
                </Col>

                <Col md={2} className="mb-2 mb-md-0">
                    <Select
                        placeholder="Gender"
                        style={{ width: '100%' }}
                        allowClear
                        value={filters.gender || undefined}
                        onChange={v => setFilters({ ...filters, gender: v || '' })}
                    >
                        <Option value="male">Male</Option>
                        <Option value="female">Female</Option>
                    </Select>
                </Col>

                <Col md={2} className="mb-2 mb-md-0">
                    <Select
                        placeholder="State"
                        style={{ width: '100%' }}
                        allowClear
                        value={filters.state || undefined}
                        onChange={v => setFilters({ ...filters, state: v || '', district: '', block: '', village: '' })}
                    >
                        {statesList.map(s => <Option key={s} value={s}>{s}</Option>)}
                    </Select>
                </Col>

                <Col md={2}>
                    <Button
                        variant="warning"
                        style={{
                            width: '100%',
                            backgroundColor: '#ef5a20',
                            borderColor: '#ef5a20',
                            color: '#fff',
                            fontWeight: 700,
                            borderRadius: '8px'
                        }}
                        onClick={onOpenExport}
                    >
                        <i className="fa fa-file-csv mr-2"></i> Export CSV
                    </Button>
                </Col>
            </Row>

            <Row className="align-items-center">
                <Col md={3} className="mb-2 mb-md-0">
                    <Select
                        placeholder="District"
                        style={{ width: '100%' }}
                        allowClear
                        value={filters.district || undefined}
                        onChange={v => setFilters({ ...filters, district: v || '', block: '', village: '' })}
                    >
                        {districtsList.map(d => <Option key={d} value={d}>{d}</Option>)}
                    </Select>
                </Col>

                <Col md={2} className="mb-2 mb-md-0">
                    <Select
                        placeholder="Block"
                        style={{ width: '100%' }}
                        allowClear
                        value={filters.block || undefined}
                        onChange={v => setFilters({ ...filters, block: v || '', village: '' })}
                    >
                        {blocksList.map(b => <Option key={b} value={b}>{b}</Option>)}
                    </Select>
                </Col>

                <Col md={2} className="mb-2 mb-md-0">
                    <Select
                        placeholder="Village"
                        style={{ width: '100%' }}
                        allowClear
                        value={filters.village || undefined}
                        onChange={v => setFilters({ ...filters, village: v || '' })}
                    >
                        {villagesList.map(v => <Option key={v} value={v}>{v}</Option>)}
                    </Select>
                </Col>

                <Col md={3} className="mb-2 mb-md-0">
                    <Select
                        placeholder="Cluster / Project"
                        style={{ width: '100%' }}
                        allowClear
                        value={filters.cluster || undefined}
                        onChange={v => setFilters({ ...filters, cluster: v || '' })}
                    >
                        {clustersList.map(c => <Option key={c} value={c}>{c}</Option>)}
                    </Select>
                </Col>

                <Col md={2}>
                    <Select
                        placeholder="Last Visited By"
                        style={{ width: '100%' }}
                        allowClear
                        value={filters.lastVisitedBy || undefined}
                        onChange={v => setFilters({ ...filters, lastVisitedBy: v || '' })}
                    >
                        {lastVisitedByList.map(v => <Option key={v} value={v}>{v}</Option>)}
                    </Select>
                </Col>
            </Row>

            {/* Active Filter Tags with Instant Dismiss */}
            <div style={{ marginTop: '14px', display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: '6px' }}>
                <span style={{ fontSize: '12px', fontWeight: 600, color: '#64748b' }}>Active Filters:</span>
                <ActiveFilterTag style={{ background: '#f1f5f9', color: '#334155', borderColor: '#cbd5e1' }}>
                    Apiary Status: Active
                </ActiveFilterTag>

                {filters.stage && (
                    <ActiveFilterTag>
                        Stage: {filters.stage === 'advance' ? 'Advanced' : 'Basic'}
                        <i className="fa fa-times-circle" onClick={() => setFilters({ ...filters, stage: '' })}></i>
                    </ActiveFilterTag>
                )}

                {filters.gender && (
                    <ActiveFilterTag>
                        Gender: {filters.gender.charAt(0).toUpperCase() + filters.gender.slice(1)}
                        <i className="fa fa-times-circle" onClick={() => setFilters({ ...filters, gender: '' })}></i>
                    </ActiveFilterTag>
                )}

                {filters.state && (
                    <ActiveFilterTag>
                        State: {filters.state}
                        <i className="fa fa-times-circle" onClick={() => setFilters({ ...filters, state: '', district: '', block: '', village: '' })}></i>
                    </ActiveFilterTag>
                )}

                {filters.district && (
                    <ActiveFilterTag>
                        District: {filters.district}
                        <i className="fa fa-times-circle" onClick={() => setFilters({ ...filters, district: '', block: '', village: '' })}></i>
                    </ActiveFilterTag>
                )}

                {filters.block && (
                    <ActiveFilterTag>
                        Block: {filters.block}
                        <i className="fa fa-times-circle" onClick={() => setFilters({ ...filters, block: '', village: '' })}></i>
                    </ActiveFilterTag>
                )}

                {filters.village && (
                    <ActiveFilterTag>
                        Village: {filters.village}
                        <i className="fa fa-times-circle" onClick={() => setFilters({ ...filters, village: '' })}></i>
                    </ActiveFilterTag>
                )}

                {filters.cluster && (
                    <ActiveFilterTag>
                        Cluster: {filters.cluster}
                        <i className="fa fa-times-circle" onClick={() => setFilters({ ...filters, cluster: '' })}></i>
                    </ActiveFilterTag>
                )}

                {filters.lastVisitedBy && (
                    <ActiveFilterTag>
                        Last Visited By: {filters.lastVisitedBy}
                        <i className="fa fa-times-circle" onClick={() => setFilters({ ...filters, lastVisitedBy: '' })}></i>
                    </ActiveFilterTag>
                )}

                {filters.srlm && (
                    <ActiveFilterTag>
                        SRLM: {filters.srlm === 'yes' ? 'Yes' : 'No'}
                        <i className="fa fa-times-circle" onClick={() => setFilters({ ...filters, srlm: '' })}></i>
                    </ActiveFilterTag>
                )}

                {isAnyFilterActive && (
                    <Button
                        variant="link"
                        size="sm"
                        style={{ color: '#ef4444', fontWeight: 700, padding: '0 8px', fontSize: '12px', textDecoration: 'none' }}
                        onClick={resetFilters}
                    >
                        Reset All Filters
                    </Button>
                )}
            </div>
        </ControlsBar>
    );
}
